import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const FixedLengthValidator: (length: number, errorMessage: string) => FormValidator = (
  length: number,
  errorMessage: string
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (value === undefined || value === null || value.length !== length) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
